<template>
  <a-modal :title="title" :width="1000" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '480px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <j-form-container :disabled="formDisabled">
        <a-form-model ref="form" :model="model" :rules="validatorRules" slot="detail" :colon="false">
            <a-row :gutter="24">
              <a-col :span="12">
                <a-form-model-item :label="$t('合同名称')" prop="contractName">
                  <a-input v-model="model.contractName" :placeholder="$t('请输入合同名称')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('合同金额(元)')" prop="contractAmount">
                  <a-input-number v-model="model.contractAmount" :placeholder="$t('请输入合同金额')" style="width: 100%" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('甲方')" prop="partyA">
                  <a-input v-model="model.partyA" :placeholder="$t('请输入甲方')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('乙方')" prop="partyB">
                  <a-input v-model="model.partyB" :placeholder="$t('请输入乙方')"></a-input>
                </a-form-model-item>
              </a-col>
              <a-col :span="24">
                <a-form-model-item :label="$t('备注说明')" prop="remark">
                  <a-textarea v-model="model.remark" :placeholder="$t('请输入备注信息')" :rows="4" />
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('合同附件')" prop="contractAnnex">
                  <!-- <a-upload name="file" :multiple="false" :fileList="fileList" :beforeUpload="beforeUpload" :remove="handleRemove" @change="handleChange">
                      <a-button>
                          <a-icon type="upload" />
                          选择附件
                      </a-button>
                  </a-upload> -->
                  <JUpload v-model="fileList" :buttonVisible="false"/>
                </a-form-model-item>
              </a-col>
              <a-col :span="12">
                <a-form-model-item :label="$t('费用附件')" prop="expensesAnnex">
                  <JUpload v-model="fileList1" :buttonVisible="false"/>
                </a-form-model-item>
              </a-col>
            </a-row>
        </a-form-model>
      </j-form-container>
    </a-spin>
  </a-modal>
</template>

<script>
  import { validateDuplicateValue,historyFileUrl } from '@/utils/util'
  import JUpload from '@/components/jeecg/JUpload'
  export default{
    components:{
      JUpload
    },
    data() {
      return {
        title: '',
        visible: false,
        disableSubmit: false,
        model: {},
        confirmLoading: false,
        validatorRules: {},
        url: {},
        fileList:[],
        fileList1:[]
      }
    },
    computed: {
      formDisabled() {
        return this.disableSubmit
      },
    },
    created() {},
    methods:{
      init(row,type){
        this.visible = true;
        this.model = JSON.parse(JSON.stringify(row));
        if (this.model.contractAnnex == null) {
          this.fileList = []
        } else {
          // this.fileList = [
          //   {
          //     uid: '1',
          //     name: this.model.contractAnnex,
          //     status: 'done ',
          //     linkProps: '{"download": "image"}', // 下载链接额外的 HTML 属性
          //     url: historyFileUrl + '/' + this.model.contractAnnex,
          //   },
          // ]
          this.fileList = [this.model.contractAnnex];
        }
        if (this.model.expensesAnnex == null) {
          this.fileList1 = []
        } else {
          this.fileList1 = [this.model.expensesAnnex];
        }
        if(type == 'detail'){
          this.disableSubmit = true;
          this.title = this.$t('详情');
        }else{
          this.disableSubmit = false;
          if(this.model.id){
            this.title = this.$t('编辑');
          }else{
            this.title = this.$t('新增');
          }
        }
      },
      handleCancel() {
        this.close()
      },
      close() {
        this.$emit('close');
        this.visible = false;
        this.disableSubmit = false;
      },
    }
  }
</script>

<style>
</style>